import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { GuestOnlyGuard } from '../core/guards/guest-only.guard';
import { AcceptInvitePageComponent } from './pages/accept-invite-page/accept-invite-page.component';
import { VendorRegistrationPageComponent } from './pages/vendor-registration-page/vendor-registration-page.component';
import { VerifyEmailAddressComponent } from './pages/verify-email-address/verify-email-address.component';
import { AuthenticatedGuard } from '../core/guards/authenticated.guard';
import { ForgottenPasswordPageComponent } from './pages/forgotten-password-page/forgotten-password-page.component';
import { PasswordResetPageComponent } from './pages/password-reset-page/password-reset-page.component';
import { TwoFactorAuthPageComponent } from './pages/two-factor-auth-page/two-factor-auth-page.component';
import { NoVendorPageComponent } from './pages/no-vendor-page/no-vendor-page.component';
import { noVendorGuard } from '../core/guards/no-vendor.guard';

const routes: Routes = [
  {
    path: 'connexion',
    component: LoginPageComponent,
    canActivate: [GuestOnlyGuard],
  },
  {
    path: 'authentification-deux-facteurs',
    component: TwoFactorAuthPageComponent,
    canActivate: [GuestOnlyGuard],
  },
  {
    path: 'mot-de-passe-oublie',
    component: ForgottenPasswordPageComponent,
    canActivate: [GuestOnlyGuard],
  },
  {
    path: 'reinitialiser-mot-de-passe',
    component: PasswordResetPageComponent,
    canActivate: [GuestOnlyGuard],
  },
  {
    path: 'accepter-invitation/:email/:token',
    component: AcceptInvitePageComponent,
  },
  {
    path: 'verifier-email/:userId/:token',
    component: VerifyEmailAddressComponent,
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'devenir-un-hote',
    component: VendorRegistrationPageComponent,
  },
  {
    path: 'sans-hote',
    component: NoVendorPageComponent,
    canActivate: [noVendorGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
